import { useEffect, useState } from "react";
import styled from "styled-components";
import WalletCard from "../../UI/Wallet/WalletCard";
import assets from "../../../assets/assets";
import axios from "axios";
import DateSelectDropdown from "../../UI/Wallet/DateSelectDropdown";
import * as XLSX from "xlsx";
import ChartCard from "../../UI/Wallet/ChartCard";
import Skeleton from "react-loading-skeleton";
import { IconController } from "../../Scripts/ImgController";
import { useAxiosKaraokeConfigGlobal } from "../../Config/axios";
import { subMonths } from "date-fns";
import NotificationPopup from "../../UI/Login/NotificationPopup";
import Ripples from "react-ripples";
import { useNavigate } from "react-router-dom";
import { karaokeUrl } from "../../Config/url";
import Pagination from "../../UI/pagination";
const Wrapper = styled.div`
  .table-border {
    border: 1px solid #e5e7eb;
    border-radius: 8px;
  }
  .color-CK {
    color: #333843;
  }
  .table-button {
    border: 1px solid #d1d5db;
    border-radius: 16px;
    display: flex;
    flex-direction: row;
    padding: 8px 12px;
    gap: 4px;
    cursor: pointer;
  }
  .table-button:hover {
    border: 1px solid #cde0ff;
    background: #cde0ff;
  }
  table {
    width: 100%;
  }

  .table-header {
    /* background: #f3f4f6; */
  }
  td {
    width: 20%;
    padding: 24px;
  }
  td:first-child {
    width: 5%;
  }
  td:nth-child(3) {
    width: 40%;
  }
  .text-color-grey {
    color: #6b7280;
  }
  tr {
    border-bottom: 1px solid #e5e7eb;
  }
  tr:last-child {
    border-bottom: none;
  }
  .table-footer {
    border-top: 1px solid #d1d5db;
    width: 100%;
    padding: 16px 24px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
  .active {
    color: #ffffff;
    background-color: #0061ff;
  }
  .incomes-number span {
    color: #10b981;
  }
  .expenses-number span {
    color: #f87171;
  }
  @media (max-width: 767px) {
    td {
      padding: 12px;
    }
    th > div {
      padding: 12px;
    }
    .table-footer {
      flex-direction: column;
      gap: 12px;
      padding: 12px;
    }
  }
`;
const KaraokeWallet = ({ oneRingRulesAll }) => {
  const navigate = useNavigate();
  const addDays = (date, days) => {
    const newDate = new Date(date);
    newDate.setDate(newDate.getDate() + days);
    return newDate;
  };
  const dateMinusOne = addDays(new Date(), -1);
  const monthsBack = subMonths(dateMinusOne, -(-5));

  useEffect(() => {
    document.title = "MMusic - Хэтэвч";
  }, []);
  const [dateFilter, setDateFilter] = useState(
    "filter[date][starts]=" +
      monthsBack.getFullYear() +
      "-" +
      (monthsBack.getMonth() + 1) +
      "-" +
      1 +
      "&filter[date][ends]=" +
      dateMinusOne.getFullYear() +
      "-" +
      (dateMinusOne.getMonth() + 1) +
      "-" +
      dateMinusOne.getDate()
  );

  const [newRequest, setNewRequest] = useState(false);

  const [cardData, setCardData] = useState();
  // const [expensesData, setExpensesData] = useState([]);
  // const [incomesData, setIncomesData] = useState([]);
  const [listData, setListData] = useState([]);
  const [listMeta, setListMeta] = useState([]);
  const [listPagination, setListPagination] = useState([]);
  const [listAllData, setListAllData] = useState([]);
  const [incomesNumber, setIncomesNumber] = useState([]);
  const [incomesDate, setIncomesDate] = useState([]);
  const [expensesNumber, setExpensesNumber] = useState([]);
  const [expensesDate, setExpensesDate] = useState([]);
  const [listRequestParams, setListRequestParams] = useState(
    "panel-api/oauth/transactions?page[number]=1&page[size]=10"
  );
  const axiosConfig = useAxiosKaraokeConfigGlobal();

  const [cardLoaded, setCardLoaded] = useState(false);
  const [listLoaded, setListLoaded] = useState(false);

  const [CKPopup, setCKPopup] = useState(false);
  const [CKPopupType, setCKPopupType] = useState("");
  const [CKPopupMessage, setCKPopupMessage] = useState("");
  useEffect(() => {
    if (sessionStorage.getItem("wallet-karaoke-cardData")) {
      const res = JSON.parse(sessionStorage.getItem("wallet-karaoke-cardData"));
      setCardData(res.data.data);
      setCardLoaded(true);
    } else {
      axios
        .get(karaokeUrl + "panel-api/oauth/statistic:wallet", axiosConfig)
        .then((res) => {
          setCardData(res.data.data);
          setCardLoaded(true);
          sessionStorage.setItem(
            "wallet-karaoke-cardData",
            JSON.stringify(res)
          );
        })
        .catch((err) => {
          if (err?.response?.status === 401) {
            oneRingRulesAll("logout");
          }
        });
    }
  }, []);
  // Carickao: ene hezee ch dahij duudagdahgui uchir tusdaa bga
  useEffect(() => {
    axios
      .get(
        karaokeUrl + "panel-api/oauth/statistic:income?" + dateFilter,
        axiosConfig
      )
      .then((res) => {
        incomesNumber.length = 0;
        incomesDate.length = 0;
        setIncomesGraphData(res.data);
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          oneRingRulesAll("logout");
        }
      });
    console.log(karaokeUrl);
    axios
      .get(
        karaokeUrl + "panel-api/oauth/statistic:expense?" + dateFilter,
        axiosConfig
      )
      .then((res) => {
        expensesNumber.length = 0;
        expensesDate.length = 0;
        setExpensesGraphData(res.data);
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          oneRingRulesAll("logout");
        }
      });
  }, [newRequest]);

  useEffect(() => {
    axios
      .get(karaokeUrl + listRequestParams + "&" + dateFilter, axiosConfig)
      .then((res) => {
        setListData(res.data.data);
        setListMeta(res.data.meta);
        setListPagination(res.data.meta.links);
        getAllListData(res.data.meta.total);
        setListLoaded(true);
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          oneRingRulesAll("logout");
        }
      });
  }, [listRequestParams, newRequest]);
  // Carickao: ene huudas ntr soligddog bolhoor bas tusdaa bgaa

  const getAllListData = (totalNumber) => {
    axios
      .get(
        karaokeUrl +
          "panel-api/oauth/transactions?page[number]=1&page[size]=10",
        axiosConfig
      )
      .then((res) => {
        setListDataFunc(res.data.data);

        // Carickao: ene function xlsx eer tatah uyd neg huudsand bugdiin oruulj ugsnuuruu yalgaatai
        // stringTranslateToMongolian();
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          oneRingRulesAll("logout");
        }
      });
  };
  const setListDataFunc = (arr) => {
    arr.forEach((item) => {
      if (item.type === "income") {
        item.type = "Орлого";
      } else if (item.type === "expense") {
        item.type = "Зарлага";
      }
    });
    setListAllData(arr);
  };
  useEffect(() => {
    setListLoaded(false);
  }, [newRequest, listRequestParams]);

  const setExpensesGraphData = (data) => {
    let rangeText;
    switch (data?.range) {
      case "month":
        rangeText = "сар";
        break;
      case "year":
        rangeText = "он";
        break;
    }
    data.data.map((a) => {
      expensesNumber.push(parseFloat(a.amount.replace(/,/g, "")));
      expensesDate.push([a.processed, rangeText]);
    });
  };
  const setIncomesGraphData = (data) => {
    let rangeText;
    // eslint-disable-next-line default-case
    switch (data?.range) {
      case "month":
        rangeText = "сар";
        break;
      case "year":
        rangeText = "он";
        break;
    }
    data.data.map((a) => {
      incomesNumber.push(parseFloat(a.amount.replace(/,/g, "")));
      incomesDate.push([a.processed, rangeText]);
    });
  };
  const mappedList = listData.map((data, key) => {
    return (
      <tr key={data?.id}>
        <td className="text-center">
          <span className="text-sm text-color-grey">
            {key + 1 + (listMeta.current_page - 1) * listMeta.per_page}
          </span>
        </td>
        <td>
          <span className="text-sm font-medium">{data?.processed_date}</span>
        </td>
        <td>
          <span className="text-sm text-color-grey">{data?.description}</span>
        </td>
        {data?.type === "income" ? (
          <td className="incomes-number">
            <span className="text-sm font-bold">{data?.amount}</span>
          </td>
        ) : (
          <td></td>
        )}
        {data?.type === "expense" ? (
          <td className="expenses-number">
            <span className="text-sm font-bold">{data?.amount}</span>
          </td>
        ) : (
          <td></td>
        )}
        {data?.type === "income" ? (
          <td>
            <button
              className="border px-3 py-2 rounded-full flex justify-end items-center max-w-xs"
              onClick={() => {
                navigate(
                  `/karaoke/incomebreakdown?date=${data?.processed_date}`
                );
              }}
            >
              <p className="text-xs text-color-grey truncate overflow-hidden whitespace-nowrap">
                Орлогын задаргаа
              </p>
              <IconController
                src={assets.svg.chevronRight}
                className="ml-2 w-5 h-5 flex-shrink-0"
              />
            </button>
          </td>
        ) : (
          ""
        )}
      </tr>
    );
  });

  const export2Excel = async () => {
    const ws = XLSX.utils.json_to_sheet(listAllData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    XLSX.writeFile(wb, "data.xlsx");
  };

  const ListSkeleton = () => {
    const arr = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
    return arr.map((a) => {
      return (
        <tr key={a}>
          <td className="text-center">
            <Skeleton />
          </td>
          <td>
            <Skeleton />
          </td>
          <td>
            <Skeleton />
          </td>
          {(a % 2 === 0 && 2 % 2 === 0) || (a % 2 !== 0 && 2 % 2 !== 0) ? (
            <td></td>
          ) : (
            <td>
              <Skeleton />
            </td>
          )}
          {(a % 2 === 0 && 2 % 2 === 0) || (a % 2 !== 0 && 2 % 2 !== 0) ? (
            <td>
              <Skeleton />
            </td>
          ) : (
            <td></td>
          )}
        </tr>
      );
    });
  };

  return (
    <Wrapper className="p-4 md:p-8">
      <h5 className="text-mmusic text-xl font-semibold pb-4 md:pb-6">Гүйлгээнүүд</h5>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-6">
        <WalletCard
          gradientColor="10B981"
          numbers={cardData?.income}
          numbersColor="166534"
          desc="Нийт орлого"
          descColor="22C55E"
          icon={assets.svg.walletTrendingUp}
          loaded={cardLoaded}
        />
        <WalletCard
          gradientColor="F59E0B"
          numbers={cardData?.expense}
          numbersColor="92400E"
          desc="Нийт олголт"
          descColor="F59E0B"
          icon={assets.svg.walletTrendingDown}
          loaded={cardLoaded}
        />
        <WalletCard
          gradientColor="0061FF"
          numbers={cardData?.balance}
          numbersColor="1E3A8A"
          desc="Олговол зохих"
          descColor="0061FF"
          icon={assets.svg.walletBalance}
          loaded={cardLoaded}
        />
      </div>

      <div className="flex flex-row pt-6 gap-8 relative">
        <div className="flex flex-col">
          <span className="font-bold pb-2">Огноо</span>

          <DateSelectDropdown
            dateFilter={dateFilter}
            setDateFilter={setDateFilter}
            width="200"
            newRequest={newRequest}
            setNewRequest={setNewRequest}
            setCKPopup={setCKPopup}
            setCKPopupType={setCKPopupType}
            setCKPopupMessage={setCKPopupMessage}
            minDate={new Date(2024, 2, 1)}
          />
        </div>
      </div>

      <div className="flex flex-col md:flex-row gap-4 md:gap-0">
        <div className="w-full md:w-1/2 md:pr-3 h-64 md:h-[340px]">
          <ChartCard
            numbers={incomesNumber}
            date={incomesDate}
            title="Орлого"
            color="336CFB"
            bgColor="0061FF"
            pointColor="93C5FD"
          />
        </div>
        <div className="w-full md:w-1/2 md:pl-3 h-64 md:h-[340px]">
          <ChartCard
            numbers={expensesNumber}
            date={expensesDate}
            title="Олголт"
            color="FAC032"
            bgColor="F9D516"
            pointColor="FCDF98"
          />
        </div>
      </div>
      {/* Carickao: end start date g saijruulahah start date ni sariinhaa zaaval ehnii udrur avdag baih */}
      <div className="pt-4 md:pt-2">
        <div className="table-border">
          <div className="px-4 md:px-6 py-4 md:py-5 flex flex-row justify-between items-center gap-3">
            <h4 className="font-medium text-base md:text-lg">Гүйлгээний хүснэгт</h4>
            <div className="flex flex-row gap-3">
              {/* <div className="table-button">
                        <span className="text-xs font-medium color-grey">Эрэмблэх</span>
                        <IconController src={assets.svg.CreationSort} className="w-4 h-4" />
                     </div> */}
              <Ripples color="#0061FF40" during={600} className="rounded-2xl">
                <div
                  className="table-button"
                  onClick={() => {
                    export2Excel();
                  }}
                >
                  <span className="text-xs font-medium tex-color-grey">
                    Татах
                  </span>
                  <IconController
                    src={assets.svg.DocumentDownload}
                    className="w-4 h-4"
                  />
                </div>
              </Ripples>
            </div>
          </div>

          <div className="overflow-x-auto">
          <table className="min-w-[720px]">
            <thead>
              <tr className="table-header">
                <th>
                  <div className="px-6 py-4 flex flex-row justify-between">
                    <h5 className="text-sm font-medium">№</h5>
                  </div>
                </th>
                <th>
                  <div className="px-6 py-4 flex flex-row justify-between">
                    <h5 className="text-sm font-medium">Огноо</h5>
                  </div>
                </th>
                <th>
                  <div className="px-6 py-4 flex flex-row justify-between">
                    <h5 className="text-sm font-medium">Тайлбар</h5>
                  </div>
                </th>
                <th>
                  <div className="px-6 py-4 flex flex-row justify-between">
                    <h5 className="text-sm font-medium">Орлого</h5>
                  </div>
                </th>
                <th>
                  <div className="px-6 py-4 flex flex-row justify-between">
                    <h5 className="text-sm font-medium">Олголт</h5>
                  </div>
                </th>
                <th>
                  <div className="px-6 py-4 flex flex-row justify-between">
                    <h5 className="text-sm font-medium"></h5>
                  </div>
                </th>
                <th>
                  <div className="px-6 py-4 flex flex-row justify-between">
                    <h5 className="text-sm font-medium"></h5>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>{listLoaded ? mappedList : ListSkeleton()}</tbody>
          </table>
          </div>
          <div className="table-footer">
            <h5 className="text-sm font-medium text-center md:text-left">
              нийт {listMeta?.total} гүйлгээнээс {listMeta?.from}-{listMeta?.to}{" "}
              харуулж байна
            </h5>
            <Pagination
              paginationLinks={listPagination}
              listMeta={listMeta}
              hostUrl={karaokeUrl}
              setRequestParams={setListRequestParams}
            />
          </div>
        </div>
      </div>
      <div className="absolute right-4 md:right-5 top-5">
        <NotificationPopup
          type={CKPopupType}
          popupMessage={CKPopupMessage}
          popup={CKPopup}
          setPopup={setCKPopup}
          animDirectionTop={true}
        />
      </div>
    </Wrapper>
  );
};

export default KaraokeWallet;
